import Active4D from './themes/Active4D.json';
import AllHallowsEve from './themes/All Hallows Eve.json';
import Amy from './themes/Amy.json';
import BirdsofParadise from './themes/Birds of Paradise.json';
import Blackboard from './themes/Blackboard.json';
import BrillianceBlack from './themes/Brilliance Black.json';
import BrillianceDull from './themes/Brilliance Dull.json';
import ChromeDevTools from './themes/Chrome DevTools.json';
import CloudsMidnight from './themes/Clouds Midnight.json';
import Clouds from './themes/Clouds.json';
import Cobalt from './themes/Cobalt.json';
import Dawn from './themes/Dawn.json';
import DominionDay from './themes/Dominion Day.json';
import Dreamweaver from './themes/Dreamweaver.json';
import Eiffel from './themes/Eiffel.json';
import EspressoLibre from './themes/Espresso Libre.json';
import GitHub from './themes/GitHub.json';
import IDLE from './themes/IDLE.json';
import idleFingers from './themes/idleFingers.json';
import iPlastic from './themes/iPlastic.json';
import Katzenmilch from './themes/Katzenmilch.json';
import krTheme from './themes/krTheme.json';
import KuroirTheme from './themes/Kuroir Theme.json';
import MagicWBAmiga from './themes/MagicWB (Amiga).json';
import MerbivoreSoft from './themes/Merbivore Soft.json';
import Merbivore from './themes/Merbivore.json';
import monoindustrial from './themes/monoindustrial.json';
import MonokaiBright from './themes/Monokai Bright.json';
import Monokai from './themes/Monokai.json';
import NightOwl from './themes/Night Owl.json';
import OceanicNext from './themes/Oceanic Next.json';
import PastelsonDark from './themes/Pastels on Dark.json';
import SlushandPoppies from './themes/Slush and Poppies.json';
import Solarizeddark from './themes/Solarized-dark.json';
import Solarizedlight from './themes/Solarized-light.json';
import SpaceCadet from './themes/SpaceCadet.json';
import Sunburst from './themes/Sunburst.json';
import TextmateMacClassic from './themes/Textmate (Mac Classic).json';
import TomorrowNightBlue from './themes/Tomorrow-Night-Blue.json';
import TomorrowNightBright from './themes/Tomorrow-Night-Bright.json';
import TomorrowNightEighties from './themes/Tomorrow-Night-Eighties.json';
import TomorrowNight from './themes/Tomorrow-Night.json';
import Tomorrow from './themes/Tomorrow.json';
import Twilight from './themes/Twilight.json';
import UpstreamSunburst from './themes/Upstream Sunburst.json';
import VibrantInk from './themes/Vibrant Ink.json';
import Xcode_default from './themes/Xcode_default.json';
import Zenburnesque from './themes/Zenburnesque.json';
import CustomTheme from './themes/CustomTheme.json';
import ExtendedLight from './themes/ExtendedLight.json';
import ExtendedDark from './themes/ExtendedDark.json';

/**
 * Lista geral de temas cadastrados.
 */
export const themes = [
  { name: 'extendedLight', theme: ExtendedLight },
  { name: 'extendedDark', theme: ExtendedDark },
  { name: 'customTheme', theme: CustomTheme },
  { name: 'Active4D', theme: Active4D },
  { name: 'AllHallowsEve', theme: AllHallowsEve },
  { name: 'Amy', theme: Amy },
  { name: 'BirdsofParadise', theme: BirdsofParadise },
  { name: 'Blackboard', theme: Blackboard },
  { name: 'BrillianceBlack', theme: BrillianceBlack },
  { name: 'BrillianceDull', theme: BrillianceDull },
  { name: 'ChromeDevTools', theme: ChromeDevTools },
  { name: 'CloudsMidnight', theme: CloudsMidnight },
  { name: 'Clouds', theme: Clouds },
  { name: 'Cobalt', theme: Cobalt },
  { name: 'Dawn', theme: Dawn },
  { name: 'DominionDay', theme: DominionDay },
  { name: 'Dreamweaver', theme: Dreamweaver },
  { name: 'Eiffel', theme: Eiffel },
  { name: 'EspressoLibre', theme: EspressoLibre },
  { name: 'GitHub', theme: GitHub },
  { name: 'IDLE', theme: IDLE },
  { name: 'idleFingers', theme: idleFingers },
  { name: 'iPlastic', theme: iPlastic },
  { name: 'Katzenmilch', theme: Katzenmilch },
  { name: 'krTheme', theme: krTheme },
  { name: 'KuroirTheme', theme: KuroirTheme },
  { name: 'MagicWBAmiga', theme: MagicWBAmiga },
  { name: 'MerbivoreSoft', theme: MerbivoreSoft },
  { name: 'Merbivore', theme: Merbivore },
  { name: 'monoindustrial', theme: monoindustrial },
  { name: 'MonokaiBright', theme: MonokaiBright },
  { name: 'Monokai', theme: Monokai },
  { name: 'NightOwl', theme: NightOwl },
  { name: 'OceanicNext', theme: OceanicNext },
  { name: 'PastelsonDark', theme: PastelsonDark },
  { name: 'SlushandPoppies', theme: SlushandPoppies },
  { name: 'Solarizeddark', theme: Solarizeddark },
  { name: 'Solarizedlight', theme: Solarizedlight },
  { name: 'SpaceCadet', theme: SpaceCadet },
  { name: 'Sunburst', theme: Sunburst },
  { name: 'TextmateMacClassic', theme: TextmateMacClassic },
  { name: 'TomorrowNightBlue', theme: TomorrowNightBlue },
  { name: 'TomorrowNightBright', theme: TomorrowNightBright },
  { name: 'TomorrowNightEighties', theme: TomorrowNightEighties },
  { name: 'TomorrowNight', theme: TomorrowNight },
  { name: 'Tomorrow', theme: Tomorrow },
  { name: 'Twilight', theme: Twilight },
  { name: 'UpstreamSunburst', theme: UpstreamSunburst },
  { name: 'VibrantInk', theme: VibrantInk },
  { name: 'Xcodedefault', theme: Xcode_default },
  { name: 'Zenburnesque', theme: Zenburnesque },
];
